import * as React from "react";
import type { SVGProps } from "react";
import { memo } from "react";
const SvgSettings = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <circle
      r={2}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      transform="matrix(-1 0 0 1 12 12)"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20 10a2 2 0 1 1 0 4M4 10a2 2 0 1 0 0 4M17.732 17.928a2 2 0 1 1-3.464 2M9.732 4.072a2 2 0 0 0-3.464 2M20 14c-1 0-2.252.043-2.804 1s-.196 1.5.304 2.5M6.5 6.5c.5 1 .856 1.543.304 2.5S5 10 4 10M14.268 4.072a2 2 0 0 1 3.464 2M6.268 17.928a2 2 0 0 0 3.464 2M17.732 6.072c-.5.866-1.088 1.971-.536 2.928s1.201.92 2.317.987M4.487 14.013c1.116.067 1.765.03 2.317.987s-.036 2.062-.536 2.928M9.732 4.072C10.232 4.938 10.896 6 12 6c1.105 0 1.397-.58 2.013-1.513"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9.987 19.513C10.603 18.58 10.896 18 12 18c1.105 0 1.768 1.062 2.268 1.928"
    />
  </svg>
);
const Memo = memo(SvgSettings);
export default Memo;
